
















import { Component, Vue, Prop } from 'vue-property-decorator'
import { MediaComponentProps } from './VideoCallRoomContainer.vue'

@Component({
  components: {
    VideoCallNotifyMessage: () => import('./VideoCallNotifyMessage.vue'),
    VideoCallMaximizedScreenContainer: () =>
      import('./VideoCallMaximizedScreenContainer.vue'),
    VideoCallSubScreenList: () => import('./VideoCallSubScreenList.vue'),
    VideoCallInvitationTool: () => import('./VideoCallInvitationTool.vue')
  }
})
export default class VideoCallRoomMaximum extends Vue {
  @Prop(Array) participants!: Array<MediaComponentProps>
  @Prop(Object) mainScreenParticipant!: MediaComponentProps
  @Prop(Boolean) on!: boolean

  handleHangUp() {
    this.$emit('hangup')
  }

  handleChangeMainScreen(id: number) {
    this.$emit('changeMainScreen', id)
  }
}
